import { ModalController } from "@ionic/angular";
import { Component, OnInit } from "@angular/core";
import { AppService } from "../../app.service";
import { UTILITIES } from "../../core/utility/utilities";
import moment from "moment";
import { CONSTANTS } from "src/app/core/constants/constants";

@Component({
  selector: "app-purchase-plan-popup",
  templateUrl: "./purchase-plan-popup.component.html",
  styleUrls: ["./purchase-plan-popup.component.scss"],
})
export class PurchasePlanPopupComponent implements OnInit {
  planData;
  selectedIndex;
  isIOSDevice = this.utilities.isDeviceiOS();
  isAndroidDevice = this.utilities.isDeviceAndroid();
  color: any = [
    "#2980B9",
    "#27AE60",
    "#FD3A69",
    "#9D0191",
    "#403E7F",
    "#FF872C",
  ];
  item: any = ["pizza.jpeg", "burger.jpeg", "icecream.jpeg", "coffee.jpeg"];
  allow7DaysRefund = CONSTANTS.Refund_policy;
  constructor(
    public modalController: ModalController,
    private appService: AppService,
    private utilities: UTILITIES
  ) {}

  ngOnInit() {
    console.log(
      "Plan data ",
      this.planData,
      " selected Index ",
      this.selectedIndex
    );
  }
  close(flag) {
    console.log("27----select modal", flag);
    let data;
    if (flag) {
      data = {
        plan: this.planData,
        selectedIndex: this.selectedIndex,
        type: flag,
      };
    }
    this.modalController.dismiss(data);
  }
  getRoundedAmount(amount, total) {
    return Math.round(amount / total);
  }

  selectPaymentMethod(i, plan) {
    console.log("Payment method ", i, " plan ", plan);
  }
}
